import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Container,
  Form,
  Input,
  FormGroup,
  Label,
  Button,
  Modal,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent
} from "reactstrap";

import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import DateTime from 'react-datetime'
import "react-datetime/css/react-datetime.css"
import AsyncSelect from 'react-select/async';
import NumberFormat from 'react-number-format'
import Iframe from 'react-iframe';

import ReactSelect from 'components/Form/Select/Select'
import useForm from "lib/useForm"
import useToggle from 'lib/useToggle'
import Loading from 'lib/loading'
import rotas from 'services/rotas'
import rest from 'lib/rest'
import {homepage} from '../../../../package.json';

const optionMargem      = [ {id:'maior', title:'>'}, {id:'igual', title:'='},{id:'menor', title:'<'} ]
const filtroTotalizado  = [
  {id:'categoria', title:'Categoria'},
  {id:'cliente', title:'Cliente'},
  {id:'convenio', title:'Convênio'},
  {id:'fornecedor', title:'Fornecedor'},
  {id:'grupocompras', title:'Grupo de Compras'},
  {id:'produto', title:'Produto'},
  {id:'subcategoria', title:'Subcategoria'},
  {id:'vendedor', title:'Vendedor'},
  {id:'tabloid', title:'Tabloid'}
]

const Lucro = () => {

  const [loading, setLoading]                                   = useState(true)
  const [loadingTabela, setLoadingTabela]                       = useState(false)
  const [loadingTabelaTotalizado, setloadingTabelaTotalizado]   = useState(false)
  const [form, onChange, setForm, onChangeSelect, onChangeDate] = useForm([])
  const [lojas, setLojas]                                       = useState([])
  const [categorias, setCategorias]                             = useState([])
  const [fornecedores, setFornecedores]                         = useState([])
  const [vendedores, setVendedores]                             = useState([])
  const [activeTab, setActiveTab]                               = useState('1')
  const [dadosDetalhado, setDadosDetalhado]                     = useState([])
  const [dadosTotalizado, setDadosTotalizado]                   = useState([])
  const [dadosTotais, setDadosTotais]                           = useState([])
  const [dadosTotaisTotalizado, setDadosTotaisTotalizado]       = useState([])
  const [pathPDF, setPathPDF]                                   = useState('')
  const [modalPrint, setModalPrint]                             = useState(false)
  const [selectTotalizado, setSelectTotalizado]                 = useState({id:'categoria', title:'Categoria'})

  const colunasDetalhado = [
    {
      dataField: 'cod_barras',
      text: 'Cód barras',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'produto',
      text: 'Produto',
      headerStyle: { cursor: 'default' },
      sort: true,
      style: (cell, row, rowIndex, colIndex) => {
        return {textAlign: 'left'}
      }
    },
    {
      dataField: 'fornecedor',
      text: 'Fornecedor',
      headerStyle: { cursor: 'default' },
      sort: true
    },
    {
      dataField: 'quant_vendida',
      text: 'Unidades',
      headerStyle: { cursor: 'default' },
      sort: true
    },
    {
      dataField: 'total_custo',
      text: 'Custo',
      headerStyle: { cursor: 'default' },
      formatter: (cellContent, row) => {return (parseFloat(cellContent).toLocaleString('pt-br', { style: 'currency', currency: 'BRL',minimumFractionDigits: 1, maximumFractionDigits: 2 }))}
    },
    {
      dataField: 'total_custo_por',
      text: 'Custo',
      headerStyle: { cursor: 'default' },
      style: (cell, row, rowIndex, colIndex) => {
        if (parseInt(cell) > 40) {
          return {
            color: '#3AAF85',
            fontWeight: 800
          };
        }
        return {
          color: '#66b2ff',
          fontWeight: 800
        };
      },
      formatter: (cellContent, row) => {return cellContent+"%"}
    },
    {
      dataField: 'total_venda',
      text: 'Venda',
      headerStyle: { cursor: 'default' },
      formatter: (cellContent, row) => {return (parseFloat(cellContent).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }))}
    },
    {
      dataField: 'lucro',
      text: 'Lucro',
      headerStyle: { cursor: 'default' },
      style: (cell, row, rowIndex, colIndex) => {
        if (parseInt(cell) > 0) {
          return {
            color: '#3AAF85',
            fontWeight: 800
          };
        }
        return {
          color: '#ff7f7f',
          fontWeight: 800
        };
      },
      formatter: (cellContent, row) => {return cellContent+"%"}
    },
    {
      dataField: 'markup',
      text: 'Markup',
      headerStyle: { cursor: 'default' },
      style: (cell, row, rowIndex, colIndex) => {
        if (parseInt(cell) > 0) {
          return {
            color: '#3AAF85',
            fontWeight: 800
          };
        }
        return {
          color: '#ff7f7f',
          fontWeight: 800
        };
      },
      formatter: (cellContent, row) => {return cellContent+"%"}
    },
  ]

  const colunasTotalizado = [
    {
      dataField: 'nome',
      text: selectTotalizado.title,
      headerStyle: { cursor: 'default' },
      sort: true
    },
    {
      dataField: 'atendimentos',
      text: 'Unidades',
      headerStyle: { cursor: 'default' },
      sort: true
    },
    {
      dataField: 'total_custo',
      text: 'Custo',
      headerStyle: { cursor: 'default' },
      formatter: (cellContent, row) => {return (parseFloat(cellContent).toLocaleString('pt-br', { style: 'currency', currency: 'BRL',minimumFractionDigits: 1, maximumFractionDigits: 2 }))}
    },
    {
      dataField: 'total_custo_por',
      text: 'Custo',
      headerStyle: { cursor: 'default' },
      style: (cell, row, rowIndex, colIndex) => {
        if (parseInt(cell) > 40) {
          return {
            color: '#3AAF85',
            fontWeight: 800
          };
        }
        return {
          color: '#66b2ff',
          fontWeight: 800
        };
      },
      formatter: (cellContent, row) => {return cellContent+"%"}
    },
    {
      dataField: 'total_venda',
      text: 'Venda',
      headerStyle: { cursor: 'default' },
      formatter: (cellContent, row) => {return (parseFloat(cellContent).toLocaleString('pt-br', { style: 'currency', currency: 'BRL',minimumFractionDigits: 1, maximumFractionDigits: 2 }))}
    },
    {
      dataField: 'lucro',
      text: 'Lucro',
      headerStyle: { cursor: 'default' },
      style: (cell, row, rowIndex, colIndex) => {
        if (parseInt(cell) > 0) {
          return {
            color: '#3AAF85',
            fontWeight: 800
          };
        }
        return {
          color: '#ff7f7f',
          fontWeight: 800
        };
      },
      formatter: (cellContent, row) => {return cellContent+"%"}
    },
    {
      dataField: 'markup',
      text: 'Markup',
      headerStyle: { cursor: 'default' },
      style: (cell, row, rowIndex, colIndex) => {
        if (parseInt(cell) > 0) {
          return {
            color: '#3AAF85',
            fontWeight: 800
          };
        }
        return {
          color: '#ff7f7f',
          fontWeight: 800
        };
      },
      formatter: (cellContent, row) => {return cellContent+"%"}
    },
  ]

  const listaLojas = () => {
    let lista = [{id: 0, title: 'TODAS'}]
    const url = rotas.lojas
    try{
      const retorno = rest.get(url)
      retorno.then(ret => {
        if (ret.success && ret.success == 'S' && ret.lista != ''){
          for (let i = 0; i < ret.lista.length; i++) {
            lista[i+1] = {"id":ret.lista[i].filial_id, "title":ret.lista[i].fantasia}
          }
          setLojas(lista)
        }
      })
    }catch(err){
      console.log(err)
    }
  }

  const listarCategorias = () => {
    const url     = rotas.categoriaSelect;
    const retorno = rest.get(url);
    retorno.then(ret => {
      if (ret.success && ret.success == 'S' && ret.lista != '' && ret.lista != null) {
        let lista = [];
        ret.lista.map(lst => {
          lista.push({ id: lst.categoria_id, title: lst.categoria });
        });
        setCategorias(lista);
      }
      setLoading(false)
    })
  }

  const listarFornecedores = () => {
    const url     = rotas.fornecedorProduto
    const retorno = rest.get(url);
    retorno.then(ret => {
      if (ret.success && ret.success == 'S' && ret.lista != '' && ret.lista != null) {
      let lista = [];
        ret.lista.map(lst => {
          lista.push({ id: lst.fornecedor_id, title: lst.fornecedor });
        });
        setFornecedores(lista);
      }
      setLoading(false)
    })
  }

  const pesquisaProduto = (produto) => {
    if (produto.length >= 3) {
      const url = rotas.filtroProdutoRelatorio;
      const retorno = rest.get(url + '?produto=' + produto);
      let rProdutos = [];
      return retorno.then(ret => {
        ret.lista.map(produto =>{
          rProdutos.push({ value: produto.produto_id, label: produto.produto, cod_barras: produto.cod_barras || '' })
      })
      return (rProdutos);
    })
    }
  }

  const listarVendedores = () => {
    const url     = rotas.vendedor;
    const retorno = rest.get(url);

    retorno.then(ret => {
      if (ret.success && ret.success == 'S' && ret.lista != '' && ret.lista != null) {
        let lista = [];
        ret.lista.map(lst => {
          lista.push({ id: lst.vendedor_id, title: lst.vendedor });
        });
        setVendedores(lista);
      }
      setLoading(false)
    })
  }

  const imprimirLucro = () => {

    if (activeTab == 1) {
      console.log(dadosDetalhado)

      if (dadosDetalhado.length > 0) {
        
        let dados = {
          rede:     sessionStorage.getItem('rede'),
          usuario:  sessionStorage.getItem('usuario'),
          dataI:    form['inicio'],
          dataF:    form['final'],
          lista:    dadosDetalhado,
          total:    dadosTotais
        }
    
        try{
          const url = rotas.lucro+"pdf/"
          const retorno = rest.post(url, dados);
    
          retorno.then(ret => {
            if (ret.success && ret.success == 'S' && ret.path != '' && ret.path != null) {
              let caminho = url.split('/');
              let caminhoPDF = '';
    
              for(let x = 0 ; x < caminho.length -1 ; x++){
                if(caminhoPDF === ''){
                  caminhoPDF = caminho[x]; 
                }else{
                  caminhoPDF = caminhoPDF + '/' + caminho[x];
                }
              }
              setPathPDF( homepage + '/' + caminhoPDF + ret.path);
              setModalPrint(true);
    
            } else {
              console.log(ret);
              // Swal.fire('Erro', 'Erro na geração da impresão', 'error');
            }
          })
        }catch(err){
          console.log(err)
        }
      }
      
    }else{
      console.log(dadosTotalizado)
      if (dadosTotalizado.length > 0) {
        let dados = {
          rede:     sessionStorage.getItem('rede'),
          usuario:  sessionStorage.getItem('usuario'),
          dataI:    form['inicio'],
          dataF:    form['final'],
          lista:    dadosTotalizado,
          total:    dadosTotais,
          filtro:   selectTotalizado.id
        }

        try{
          const url = rotas.lucro+"pdf/totalizado.php"
          const retorno = rest.post(url, dados);
    
          retorno.then(ret => {
            if (ret.success && ret.success == 'S' && ret.path != '' && ret.path != null) {
              let caminho = url.split('/');
              let caminhoPDF = '';
    
              for(let x = 0 ; x < caminho.length -1 ; x++){
                if(caminhoPDF === ''){
                  caminhoPDF = caminho[x]; 
                }else{
                  caminhoPDF = caminhoPDF + '/' + caminho[x];
                }
              }
              setPathPDF( homepage + '/' + caminhoPDF + ret.path);
              setModalPrint(true);
    
            } else {
              console.log(ret);
            }
          })
        }catch(err){
          console.log(err)
        }

      }
    }
  }

  const pesquisaSubmit = (e) => {
    e.preventDefault()

    const url     = rotas.lucro
    const retorno = rest.post(url, form)
    setLoadingTabela(true)

    try {
      retorno.then(ret => {
        console.log(ret);
        if (ret.success && ret.success == 'S'){
          setDadosDetalhado(ret.lista)
          setDadosTotais(ret.totais)
        }else{
          setDadosDetalhado([])
        }
        setLoadingTabela(false)
      })
    } catch (error) {
      console.log(error);
      setLoadingTabela(false)
    }

    let dados = {
      form :  form,
      filtro: selectTotalizado.id
    }

    const urlTotalizado     = rotas.lucro+'/totalizado.php'
    const retornoTotalizado = rest.post(urlTotalizado, dados)
    try {
      retornoTotalizado.then(retTot => {
        console.log(retTot);
        if (retTot.success && retTot.success == 'S'){
          setDadosTotalizado(retTot.lista)
          setDadosTotaisTotalizado(retTot.totais)
        }else{
          setDadosTotalizado([])
        }
        setLoadingTabela(false)
    })
    } catch (error) {
      console.log(error);
      setLoadingTabela(false)
    }
  }

  const onChangeFiltroTotalizado = (select) => {

    setloadingTabelaTotalizado(true)
    console.log(select)

    let dados = {
      form :  form,
      filtro: select.id
    }

    const urlTotalizado     = rotas.lucro+'/totalizado.php'
    const retornoTotalizado = rest.post(urlTotalizado, dados)
    try {
      retornoTotalizado.then(retTot => {
        console.log(retTot);
        setSelectTotalizado(select)

        if (retTot.success && retTot.success == 'S'){
          setDadosTotalizado(retTot.lista)
          setDadosTotaisTotalizado(retTot.totais)
        }else{
          setDadosTotalizado([])
        }
        setloadingTabelaTotalizado(false)
    })
    } catch (error) {
      console.log(error);
      setloadingTabelaTotalizado(false)
    }

  }

  useEffect(() => {
    listaLojas()
    listarCategorias()
    listarFornecedores()
    listarVendedores()
  }, [])

  if (loading) {
    return ( <Loading tipo='paginas' /> )

  } else {
    return (
      <div className="content" key="585">
        <Container>
          <Row>
            <Col md="12" className="p-0">
              <Card>
                <CardHeader>
                  <CardTitle>ESTATÍSTICA DE LUCRO</CardTitle>
                </CardHeader>

                <CardBody>
                  <div className="border p-3">
                    <Form onSubmit={pesquisaSubmit}>
                      <Container>
                        <Row>

                          <Col md='4'>
                            <FormGroup className="mb-0">
                              <ReactSelect
                                isMulti
                                name          = "lojas"
                                placeholder   = "Selecione a Loja"
                                options       = {lojas}
                                defaultValue  = {form.filialSelect}
                                onChange      = {onChangeSelect('filialSelect')}
                                onClick       = {form.filialSelect ? form.filial = form.filialSelect.id : ''}
                              ></ReactSelect>
                            </FormGroup>
                          </Col>
                          
                          <Col md="4">
                            <FormGroup className="mb-0">
                            <AsyncSelect
                              isMulti
                              cacheOptions 
                              defaultOptions 
                              id              = "selectProdutos"
                              name            = "selectProdutos"
                              classNamePrefix = "react-select"
                              placeholder     = "Selecione o Produto"
                              loadOptions        = {pesquisaProduto}
                              onChange           = {onChangeSelect('produtoSelect')}
                              onClick            = {form.produtoSelect ? form.produto_id = form.produtoSelect.id : ''}
                              noOptionsMessage   = {() => "Nenhum produto encontrado"}
                              loadingMessage     = {() => "Buscando..."}
                              formatOptionLabel  = {(opt) => (
                                <div>
                                  <div style={{ fontSize: '13px' }}>{opt.label}</div>
                                  {opt.cod_barras && <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '1px' }}><i className="ti ti-barcode" style={{ fontSize: '12px', marginRight: '4px' }} aria-hidden="true" />{opt.cod_barras}</div>}
                                </div>
                              )}
                            />
                            </FormGroup>
                          </Col>

                          <Col md='2'>
                            <FormGroup className="mb-0">
                              <DateTime
                                id            = "dataInicial"
                                name          = "dataInicial"
                                inputProps    = {{ placeholder: "Período Inicial" }}
                                closeOnSelect = {true}
                                dateFormat    = "DD/MM/YYYY"
                                timeFormat    = {false}
                                value         = {form.inicio}
                                onChange      = {onChangeDate('inicio')}
                              >
                              </DateTime>
                            </FormGroup>
                          </Col>

                          <Col md='2'>
                            <FormGroup className="mb-0">
                              <DateTime
                                id            = "dataFinal"
                                name          = "dataFinal"
                                inputProps    = {{ placeholder: "Período Final" }}
                                closeOnSelect = {true}
                                timeFormat    = {false}
                                dateFormat    = "DD/MM/YYYY"
                                value         = {form.final}
                                onChange      = {onChangeDate('final')}
                              >
                              </DateTime>
                            </FormGroup>
                          </Col>

                          <Col md="4">
                            <FormGroup className="mb-0 mt-3">
                              <ReactSelect
                                isMulti
                                id              = 'slecFornecedor'
                                name            = "selectFornecedor"
                                placeholder     = "Selecione o Fornecedor"
                                options         = {fornecedores}
                                onChange        = {onChangeSelect('fornecedorSelect')}
                                onClick         = {form.fornecedorSelect ? form.fornecedor_id = form.fornecedorSelect.id : ''}
                              />
                            </FormGroup>
                          </Col>

                          <Col md="4">
                            <FormGroup className="mb-0 mt-3">
                              <ReactSelect
                                isMulti
                                id              = "selectVendedor"
                                name            = "selectVendedor"
                                classNamePrefix = "react-select"
                                placeholder     = "Selecione o Vendedor"
                                options         = {vendedores}
                                onChange        = {onChangeSelect('vendedorSelect')}
                                onClick         = {form.vendedorSelect ? form.vendedor_id = form.vendedorSelect.id : ''}
                              />
                            </FormGroup>
                          </Col>

                          <Col md="4">
                            <FormGroup className="mb-0 mt-3">
                              <ReactSelect
                                isMulti
                                id              = "selectCategoria"
                                name            = "selectCategoria"
                                classNamePrefix = "react-select"
                                placeholder     = "Selecione a Categoria"
                                options         = {categorias}
                                onChange        = {onChangeSelect('categoriaSelect')}
                                onClick         = {form.categoriaSelect ? form.categoria_id = form.categoriaSelect.id : ''}
                              />
                            </FormGroup>
                          </Col>

                          <Col md="4">
                            <div className="card-2 pl-3 ml-0">
                              <Col md="12">
                                <span className="tag-card">
                                  Selecione o cálculo da compra
                                </span>
                              </Col>

                              <FormGroup className="mb-0">
                                <Row className='d-flex justify-content-around'>

                                  <div className="form-check-radio  mb-2 mt-2" >
                                    <Label className="form-check-label">
                                      <Input
                                        id        = "ultCompra"
                                        name      = "tipoCusto"
                                        type      = "radio"
                                        value     = "UC"
                                        checked   = {form.compra == 'UC' ? true : false}
                                        onChange  = {onChange('compra')}
                                      />
                                      Última compra
                                      <span className="form-check-sign"></span>
                                    </Label>
                                  </div>

                                  <div className="form-check-radio mb-2 mt-2" >
                                    <Label className="form-check-label">
                                      <Input
                                        id        = "cmv"
                                        name      = "tipoCusto"
                                        type      = "radio"
                                        value     = "CMV"
                                        checked   = {form.compra == 'CMV' ? true : false}
                                        onChange  = {onChange('compra')}
                                      />
                                      CMV (custo médio)
                                      <span className="form-check-sign"></span>
                                    </Label>
                                  </div>

                                </Row>
                              </FormGroup>
                            </div>
                          </Col>

                          <Col md="6">
                            {/* <div className="card-2 pl-3 ml-0">
                              <Col md="12">
                                <span className="tag-card">
                                  Margem
                                </span>
                              </Col>

                              <FormGroup className="mb-0">
                                <Row className='d-flex justify-content-around'>
                                  <div className="form-check-radio mb-0" >
                                    <Label className="form-check-label">
                                      <Input
                                        id        = "margeLucro"
                                        name      = "margem"
                                        type      = "radio"
                                        value     = "lucro"
                                        checked   = {form.margem == 'lucro' ? true : false}
                                        onChange  = {onChange('margem')}
                                      />
                                      Lucro
                                      <span className="form-check-sign"></span>
                                    </Label>
                                  </div>

                                  <div className="form-check-radio mb-0" >
                                    <Label className="form-check-label">
                                      <Input
                                        id        = "margeMarkup"
                                        name      = "margem"
                                        type      = "radio"
                                        value     = "markup"
                                        checked   = {form.margem == 'markup' ? true : false}
                                        onChange  = {onChange('margem')}
                                      />
                                      Markup
                                      <span className="form-check-sign"></span>
                                    </Label>
                                  </div>

                                  <div className="form-check-radio mb-0" >
                                    <Label className="form-check-label">
                                      <Input
                                        id        = "margeCusto"
                                        name      = "margem"
                                        type      = "radio"
                                        value     = "total_custo"
                                        checked   = {form.margem == 'total_custo' ? true : false}
                                        onChange  = {onChange('margem')}
                                      />
                                      Custo
                                      <span className="form-check-sign"></span>
                                    </Label>
                                  </div>
                                </Row>
                              </FormGroup>

                              <FormGroup className="mb-0 mt-2">
                                <Row className='d-flex justify-content-around'>
                                  <Col md='6'>
                                    <FormGroup className="mb-0">
                                      <ReactSelect
                                        id              = "margemSimbolo"
                                        name            = "margemSimbolo"
                                        classNamePrefix = "react-select"
                                        placeholder     = ">, =, <"
                                        options         = {optionMargem}
                                        onChange        = {onChangeSelect('margemSimboloSelect')}
                                        onClick         = {form.margemSimboloSelect ? form.margemSimbolo = form.margemSimboloSelect.id : ''}
                                      />
                                    </FormGroup>
                                  </Col>
                                  <Col md='6'>
                                    <FormGroup className="mb-0">
                                      <NumberFormat
                                        fixedDecimalScale
                                        id                = "margemValor"
                                        name              = "margemValor"
                                        className         = {"form-control text-success"}
                                        placeholder       = "0.00"
                                        maxLength         = {20}
                                        decimalScale      = {2}
                                        allowNegative     = {false}
                                        suffix            = {' %'}
                                        decimalSeparator  = {','}
                                        value             = {form.margemValor}
                                        onChange          = {onChange('margemValor')}
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </FormGroup>

                            </div> */}

                            <div className="card-2 pl-3 ml-0">
                              <Col md="12">
                                <span className="tag-card">
                                  Filtrar por Margem
                                </span>
                              </Col>

                              <FormGroup className="mb-0">
                                <Row className='d-flex justify-content-around'>
                                  <div className="form-check-radio mb-2 mt-2" >
                                    <Label className="form-check-label">
                                      <Input
                                        id        = "margeLucro"
                                        name      = "margem"
                                        type      = "radio"
                                        value     = "lucro"
                                        checked   = {form.margem == 'lucro' ? true : false}
                                        onChange  = {onChange('margem')}
                                      />
                                      Lucro
                                      <span className="form-check-sign"></span>
                                    </Label>
                                  </div>

                                  <div className="form-check-radio mb-2 mt-2" >
                                    <Label className="form-check-label">
                                      <Input
                                        id        = "margeMarkup"
                                        name      = "margem"
                                        type      = "radio"
                                        value     = "markup"
                                        checked   = {form.margem == 'markup' ? true : false}
                                        onChange  = {onChange('margem')}
                                      />
                                      Markup
                                      <span className="form-check-sign"></span>
                                    </Label>
                                  </div>

                                  <div className="form-check-radio mb-2 mt-2" >
                                    <Label className="form-check-label">
                                      <Input
                                        id        = "margeCusto"
                                        name      = "margem"
                                        type      = "radio"
                                        value     = "total_custo_por"
                                        checked   = {form.margem == 'total_custo_por' ? true : false}
                                        onChange  = {onChange('margem')}
                                      />
                                      Custo
                                      <span className="form-check-sign"></span>
                                    </Label>
                                  </div>

                                  <Col md='3'>
                                    <FormGroup className="mb-0 mt-0">
                                      <ReactSelect
                                        id              = "margemSimbolo"
                                        name            = "margemSimbolo"
                                        classNamePrefix = "react-select"
                                        placeholder     = ">, =, <"
                                        options         = {optionMargem}
                                        onChange        = {onChangeSelect('margemSimboloSelect')}
                                        onClick         = {form.margemSimboloSelect ? form.margemSimbolo = form.margemSimboloSelect.id : ''}
                                      />
                                    </FormGroup>
                                  </Col>

                                  <Col md='3'>
                                    <FormGroup className="mb-0 mt-0">
                                      <NumberFormat
                                        fixedDecimalScale
                                        id                = "margemValor"
                                        name              = "margemValor"
                                        className         = {"form-control text-success"}
                                        placeholder       = "0.00"
                                        maxLength         = {20}
                                        decimalScale      = {2}
                                        allowNegative     = {false}
                                        suffix            = {' %'}
                                        decimalSeparator  = {','}
                                        value             = {form.margemValor}
                                        onChange          = {onChange('margemValor')}
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </FormGroup>

                            </div>

                          </Col>

                          <Col md="2">
                          <FormGroup className="mt-3">
                            <Button
                              color="success"
                              // onClick={() => { lista_contasPagar() }}
                            >Gerar
                              <i className="nc-icon nc-zoom-split pl-2"
                                style={{ fontSize: '18px' }}
                              />
                            </Button>
                          </FormGroup>
                          </Col>
                          
                        </Row>
                      </Container>

                    </Form>
                  </div>

                  <Row>

                    {
                      loadingTabela ?  <Col md="12" className="mt-3"><Loading tipo='componente' /></Col>
                      :
                      <Col md="12" className="mt-3">

                        <Nav pills className="nav-pills-default justify-content-center mb-3">
                          <NavItem>
                            <NavLink
                              className = {activeTab == '1' ? 'active' : ''}
                              onClick   = {() => setActiveTab('1')}
                            >
                              Detalhado
                            </NavLink>
                          </NavItem>

                          <NavItem>
                            <NavLink
                              className = {activeTab == '2' ? 'active' : ''}
                              onClick   = {() => setActiveTab('2')}
                            >
                              Totalizado
                            </NavLink>
                          </NavItem>
                        </Nav>

                        <TabContent activeTab={activeTab}>
                          <TabPane tabId="1">
                            
                            <BootstrapTable
                              striped
                              keyField          = 'index'
                              data              = {dadosDetalhado}
                              columns           = {colunasDetalhado}
                              noDataIndication  = "Nenhum registro encontrado"
                              pagination        = {paginationFactory({
                                                    sizePerPage: 20,
                                                    hideSizePerPage: true,
                                                    hidePageListOnlyOnePage: true,
                                                    showTotal: false,
                                                  })}
                              rowStyle          = {{ cursor: "pointer" }}                          
                            />

                          </TabPane>
                        </TabContent>

                        <TabContent activeTab={activeTab}>
                          <TabPane tabId="2">
                            <Row style={{ display: "flex", justifyContent: "center", }}>
                              <Col md='4'>
                                <FormGroup className="mb-3">
                                  <Label for="filtroTotalizado">Selecione o agrupamento</Label>
                                  <ReactSelect
                                    name          = "filtroTotalizado"
                                    placeholder   = "Selecione o filtro"
                                    options       = {filtroTotalizado}
                                    defaultValue  = {selectTotalizado}
                                    onChange      = {onChangeFiltroTotalizado}
                                    // onClick       = {}
                                  ></ReactSelect>
                                </FormGroup>
                              </Col>

                            </Row>

                            {
                              loadingTabelaTotalizado ?  <Col md="12" className="mt-3"><Loading tipo='componente' /></Col>
                              :
                              <BootstrapTable
                                striped
                                keyField          = 'cod_barras'
                                data              = {dadosTotalizado}
                                columns           = {colunasTotalizado}
                                noDataIndication  = "Nenhum registro encontrado"
                                pagination        = {paginationFactory({
                                                      sizePerPage: 20,
                                                      hideSizePerPage: true,
                                                      hidePageListOnlyOnePage: true,
                                                      showTotal: false,
                                                    })}
                                rowStyle          = {{ cursor: "pointer" }}                          
                              />
                            }

                          </TabPane>
                        </TabContent>
                      
                        <Row>
                          <Col md='2'>
                            <FormGroup>
                              <Label for="custo">Custo</Label>
                              <NumberFormat
                                required
                                fixedDecimalScale
                                disabled
                                id                = "custo"
                                name              = "custo"
                                className         = {"form-control text-danger"}
                                placeholder       = "0,00"
                                maxLength         = {20}
                                decimalScale      = {2}
                                allowNegative     = {false}
                                prefix            = {"R$ "}
                                decimalSeparator  = {','}
                                thousandSeparator = "." 
                                value             = {dadosTotais.custo}
                              />
                            </FormGroup>
                          </Col>

                          <Col md='2'>
                            <FormGroup>
                              <Label for="venda">Venda</Label>
                              <NumberFormat
                                required
                                fixedDecimalScale
                                id                = "venda"
                                name              = "venda"
                                placeholder       = "0,00"
                                maxLength         = {20}
                                decimalScale      = {2}
                                allowNegative     = {false}
                                className         = {"form-control text-success"}
                                prefix            = {"R$ "}
                                decimalSeparator  = {','}
                                thousandSeparator = "." 
                                value             = {dadosTotais.venda}
                                disabled          = {true}
                              />
                            </FormGroup>
                          </Col>

                          <Col md='2'>
                            <FormGroup>
                              <Label for="lucro">Lucro</Label>
                              <NumberFormat
                                required
                                fixedDecimalScale
                                id                = "lucro"
                                name              = "lucro"
                                className         = {"form-control text-success"}
                                placeholder       = "0.00"
                                maxLength         = {20}
                                decimalScale      = {2}
                                allowNegative     = {false}
                                suffix            = {' %'}
                                decimalSeparator  = {','}
                                value             = {dadosTotais.lucro}
                                disabled          = {true}
                              />
                              
                            </FormGroup>
                          </Col>

                          <Col md='2'>
                            <FormGroup>
                              <Label for="markup">Markup</Label>
                              <NumberFormat
                                required
                                fixedDecimalScale
                                id                = "markup"
                                name              = "markup"
                                placeholder       = "0,00"
                                maxLength         = {20}
                                decimalScale      = {2}
                                allowNegative     = {false}
                                className         = {"form-control text-success"}
                                suffix            = {' %'}
                                decimalSeparator  = {','}
                                value             = {dadosTotais.markup}
                                disabled          = {true}
                              />
                            </FormGroup>
                          </Col>
                          
                          <Col md='2'>
                            <FormGroup>
                              <Label for="quantidade">Quantidade</Label>
                              <NumberFormat
                                fixedDecimalScale
                                id                = "quantidade"
                                name              = "quantidade"
                                placeholder       = "0"
                                maxLength         = {20}
                                allowNegative     = {false}
                                className         = {"form-control"}
                                value             = {dadosTotais.quantidade}
                                disabled          = {true}
                              />
                            </FormGroup>
                          </Col>

                          <Col md="2" className="d-flex pt-2">
                            <Button
                              block
                              color     = "warning"
                              onClick   = {imprimirLucro}
                            >IMPRIMIR</Button>
                          </Col>
                        </Row>
                      </Col>
                    }
                  </Row>

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <Modal
          key     = 'modrelat'
          size    = 'xl'
          height  = "700px"
          isOpen  = {modalPrint}
        >
          <Iframe
            allowFullScreen
            id        = "myId"
            name      = "myId"
            className = "myClassname"
            width     = "100%"
            height    = "580px"
            display   = "initial"
            position  = "relative"
            url       = {pathPDF}
            >
          </Iframe>
          <Row>
            <Col className="text-center p-3">
              <Button
                type      = "button"
                className = "mb-0 mt-0"
                color     = "success"
                size      = "md"
                onClick   = {()=>{window.open(pathPDF)}}
              >Baixar
                </Button>
              <Button
                type      = "button"
                className = "mb-0 mt-0"
                color     = "default"
                size      = "md"
                onClick   = {()=>{setModalPrint(false)}}>Fechar</Button>
            </Col>
          </Row>
        </Modal>

      </div>
    )
  }
}

export default Lucro;